module.exports = {
    // login_url: 'https://auth.matayze.shenkar.cloud/login?response_type=token&client_id=3uslmcib25uq3sah74hp6lgvr9&redirect_uri=http://localhost:3000'
    login_url:'https://auth.matayze.shenkar.cloud/login?response_type=token&client_id=3uslmcib25uq3sah74hp6lgvr9&redirect_uri=https://matayze.shenkar.cloud/index.html'
    ,api_link_get : 'https://api.matayze.shenkar.cloud/v1/lectures',
    api_link_post:  'https://api.matayze.shenkar.cloud/v1/lectures',
    message_link:   'https://api.matayze.shenkar.cloud/v1/'
}